import {
  ApplicationRef,
  createComponent,
  EnvironmentInjector,
  Inject,
  Injectable,
  Injector,
  NgZone,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import {
  SINGAPORE_SUB_REGION,
  SingaporeSubRegion,
} from './shareModule/services/google-maps.interface';
import { SharedService } from './shareModule/services/shared.service';
import { RoleService } from './shareModule/services/roles/role.service';
import { LocalServiceService } from './shareModule/services/local-service.service';
import { AuthServiceService } from './shareModule/services/auth-service.service';
import { AppState } from './shareModule/states/app.state';
import { CommonService } from './shareModule/services/common.service';
import { Store } from '@ngrx/store';
import { environment } from 'src/environments/environment';
import { Subscription, Observable, of, Subject, BehaviorSubject } from 'rxjs';
import { CustomerService } from './shareModule/services/customer.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { CommonProductCardViewComponent } from './customers/common/common-product-card-view/common-product-card-view.component';
import { PromoCardComponent } from './promo-card/promo-card.component';

declare const google: any;

@Injectable({
  providedIn: 'root',
})
export class GoogleMapsService implements OnDestroy {
  public imgUrl = environment.ImageUrl;

  constructor(
    private customerService: CustomerService,
    private modalService: NgbModal,
    private sharedService: SharedService,
    private ngZone: NgZone,
    private breakpointObserver: BreakpointObserver,
    public roleService: RoleService,
    private local: LocalServiceService,
    private auth: AuthServiceService,
    private store: Store<AppState>,
    public commonService: CommonService,
    private appRef: ApplicationRef,
    private injector: Injector,
    private envInjector: EnvironmentInjector,
    @Inject('WINDOW') private window: any
  ) { }

  ngOnDestroy(): void {
    this._mobileDetectionSubscription?.unsubscribe();
  }

  public static get singaporeCenter() {
    return `{
        "lat": 1.3521,
        "lng": 103.8198
      }`;
  }
  private isOnMobile = false;

  private map: any = null;

  private lat: number = 1.3521;
  private lng: number = 103.8198;

  private getMapDiv() {
    return this.map.getDiv();
  }
  public getMapWidth() {
    return this.getMapDiv()?.offsetWidth ?? 0;
  }
  public getMapHeight() {
    return this.getMapDiv()?.offsetHeight ?? 0;
  }
  public closeCurrentInfoWinddow() {
    this.currentActiveInfoWindow?.close();
    this.currentActiveInfoWindow = null;
  }

  public getBounds() {
    const bounds = this.map.getBounds();
    //console.log('bounds', bounds)

    if (bounds) {
      const northEast = bounds.getNorthEast();
      const southWest = bounds.getSouthWest();
      //console.log({northEast, southWest})

      const rv = {
        fromLat: southWest.lat(),
        toLat: northEast.lat(),

        fromLng: southWest.lng(),
        toLng: northEast.lng(),
      };
      //console.log({rv})

      return rv;

      // //console.log("North-East:", northEast.lat(), northEast.lng());
      // //console.log("South-West:", southWest.lat(), southWest.lng());
    }

    return null;
  }

  public panTo(latLng: any) {
    if (
      this.map &&
      latLng &&
      (typeof latLng == 'object' || typeof latLng == 'string')
    ) {
      //console.log('panning', latLng);
      this.map.panTo(typeof latLng == 'string' ? JSON.parse(latLng) : latLng);
    } else {
      console.error('latLang is not an object', typeof latLng);
    }
  }

  private async getLatLongByPostalCode(address: any): Promise<any> {
    if (!address) return null;
    try {
      const result = await this.local.getLatLongByPostalCode(address);
      if (typeof result === 'string') {
        return JSON.parse(result);
      }
      // //console.log({result})
      return result;
    } catch (e) {
      console.error(e);
      return null;
    }
  }

  private singaporeSubregions: { [key: number]: SingaporeSubRegion } =
    SINGAPORE_SUB_REGION;

  fitBounds() {
    if (this.markers.length > 0 && this.mapBounds && this.map) {
      try {
        this.map.fitBounds(this.mapBounds);
      } catch (e) {
        // Defensive: fitBounds can throw if bounds are invalid
        console.error('fitBounds error:', e);
      }
    }
  }

  public getCenter() {
    return {
      lat: this.map?.getCenter()?.lat(),
      lng: this.map?.getCenter()?.lng(),
    };
    //return this.map?.getCenter();
  }
  public usersLatLong = null;
  public async addMarkerToLocation(
    latLong,

    panToLocation = false
  ) {
    try {
      if (typeof latLong === 'string') {
        latLong = JSON.parse(latLong);
      }
    } catch (e) {
      console.error(e);
      return;
    }
    if (!latLong || !latLong.lat || !latLong.lng) return;

    this.mapBounds?.extend(latLong);
    let marker = null
    if (this.map) {
      marker = new google.maps.Marker({
        position: latLong,
        map: this.map,
      });
      if (panToLocation) {
        this.panTo(latLong);
      }

      this.markers.push(marker);
    }
    return marker
  }

  private mapBounds: any = null;

  serviceSelectedRegion = null;

  private _fitMapToRadius(center, radiusMeters) {
    if (!center) {
      //console.log('invalid center:', center);
      return;
    }
    if (typeof center == 'string') {
      center = JSON.parse(center);
    }
    if (
      typeof center != 'object' ||
      !(typeof center.lat == 'number' && typeof center.lng == 'number')
    ) {
      console.error('invalid center:', center);
      return;
    }
    const earthRadius = 6378137; // in meters
    const lat = (center.lat * Math.PI) / 180;
    const lng = (center.lng * Math.PI) / 180;

    // Convert meters to degrees
    const latOffset = (radiusMeters / earthRadius) * (180 / Math.PI);
    const lngOffset =
      (radiusMeters / (earthRadius * Math.cos(lat))) * (180 / Math.PI);

    const bounds = new google.maps.LatLngBounds(
      { lat: center.lat - latOffset, lng: center.lng - lngOffset },
      { lat: center.lat + latOffset, lng: center.lng + lngOffset }
    );

    this.map.fitBounds(bounds);
  }
  public reCenter(km = null) {
    try {
      //console.log('userLatLong', this.usersLatLong);
      if (this.usersLatLong) {
        this.panTo(this.usersLatLong);
        if (km) {
          // this._fitMapToRadius(this.usersLatLong, km * 1000);
        }
      }
    } catch (e) {
      console.error(e);
    }
  }

  public currentZoom = 12;

  public setZoom(zoom: number) {
    if (this.map && typeof zoom === 'number') {
      // this.reCenter()
      this.map.setZoom(zoom);
      this.currentZoom = zoom;
    }
  }

  public removeCurrentMap() {
    if (!this.sharedService.isBrowser()) return;
    if (this.map) {
      try {
        google.maps.event.clearInstanceListeners(this.map);
      } catch (e) { }
      this.map = null;
    }
  }
  private _mobileDetectionSubscription?: Subscription = null;
  private _detectIfMobile() {
    this._mobileDetectionSubscription?.unsubscribe();
    this._mobileDetectionSubscription = this.breakpointObserver
      .observe([Breakpoints.Small, Breakpoints.XSmall])
      .subscribe((result) => {
        this.isOnMobile = result.matches;
      });
  }

  public createMap(mapDivId, options = {}) {
    this._detectIfMobile();
    if (!this.sharedService.isBrowser()) {
      return;
    }

    const mapDiv = document.getElementById(mapDivId);
    if (!mapDiv) {
      console.error('map div not found!');
    }
    try {
      if (this.isOnMobile) {
        this.MAP_CONFIG.zoom = 11; //mobile needs to pull out
      }
      this.MAP_CONFIG.center = JSON.parse(
        this.local.getUser()?.latLong ?? GoogleMapsService.singaporeCenter
      );
    } catch (e) {
      // console.error(e)
    }
    return new google.maps.Map(mapDiv, { ...this.MAP_CONFIG, ...options });
  }
  public panSubject = new Subject<boolean>();
  private _addMapZoomEvents() {
    const mapElement = this.map.getDiv(); // map DOM element
    google.maps.event.addListener(this.map, 'zoom_changed', () => {
      this.panSubject.next(true);
    });
    mapElement.addEventListener('zoom_changed', () => {
      this.panSubject.next(true);
    });
    // let pinchStartDistance: number | null = null;
    // mapElement.addEventListener('scroll')
    // mapElement.addEventListener('touchstart', (event: TouchEvent) => {
    //   if (event.touches.length === 2) {
    //     //console.log('pintch touch type')
    //     const dx = event.touches[0].clientX - event.touches[1].clientX;
    //     const dy = event.touches[0].clientY - event.touches[1].clientY;
    //     pinchStartDistance = Math.sqrt(dx * dx + dy * dy);
    //     //console.log({pinchStartDistance})
    //   }else{
    //     //console.log('unknown touch type')
    //   }
    // });

    // mapElement.addEventListener('touchmove', (event: TouchEvent) => {
    //   if (event.touches.length === 2 && pinchStartDistance !== null) {
    //     const dx = event.touches[0].clientX - event.touches[1].clientX;
    //     const dy = event.touches[0].clientY - event.touches[1].clientY;
    //     const currentDistance = Math.sqrt(dx * dx + dy * dy);
    //     //console.log({pinchStartDistance}, 'from move')
    //     if (currentDistance > pinchStartDistance) {

    //      // this.setZoom(this.currentZoom + 1);
    //       //console.log('User attempting pinch zoom OUT', this.currentZoom);
    //       this.panSubject.next(true)
    //     } else if (currentDistance < pinchStartDistance) {

    //       //this.setZoom(this.currentZoom - 1);
    //       //console.log('User attempting pinch zoom IN', this.currentZoom);
    //       this.panSubject.next(false)
    //     }

    //     pinchStartDistance = currentDistance;
    //   }
    // });

    // mapElement.addEventListener('touchend', () => {
    //   pinchStartDistance = null;
    // });
  }

  private _usersMarker = null;
  public addUsersMarkerOnMap(pan = false) {
    const user = this.local.getUser();
    try {
      this._usersMarker?.setMap(null)
    } catch (e) {

    }

    if (user?.postalCode) {
      this.getLatLongByPostalCode(user.postalCode.trim())
        .then((loc) => {
          this.usersLatLong = loc;
          // //console.log('user lat long is ', this.usersLatLong, loc,  user.postalCode.trim())
          this._usersMarker = this.addMarkerToLocation(loc, pan);
        })
        .catch(console.error);
    } else if (this.usersLatLong) {
      this.addMarkerToLocation(this.usersLatLong, pan);
    } else {
      this._usersMarker = this.addMarkerToLocation(GoogleMapsService.singaporeCenter, pan);
      //console.log('user has no postalcode', user)
    }
  }

  private pinSubject = new Subject();
  public pinSubject$ = this.pinSubject.asObservable();
  public initPinMap(map, mapDivId) {
    //console.log({arguments})
    try {
      if (!this.sharedService.isBrowser()) {
        return;
      }
      if (!map) {
        console.error('map is empty!');
        return;
      }
      // if(this.map){
      //   //console.log("already inited")
      //   return; //already inited
      // }

      this.removeCurrentMap();

      this.mapDivId = mapDivId;
      this.map = map;

      this.map.addListener('click', (event: any) => {
        this.removeAllMarkers();
        this.addMarkerToLocation(event.latLng, true);
        this.pinSubject.next(event.latLng);
      });
    } catch (e) {
      console.error(e);
    }
  }

  public initProductMap(map, mapDivId: string): void {
    try {
      if (!this.sharedService.isBrowser()) {
        return;
      }

      this.fetchCategories();

      this.mapDivId = mapDivId;
      this.map = map;

      const user = this.local.getUser();

      let subRegionId = 59;
      if (user && user.region) {
        subRegionId = user.region;
      }

      const region = this.singaporeSubregions[subRegionId];

      // Defensive: create new bounds for each map instance
      this.mapBounds = this.sharedService.isBrowser()
        ? new google.maps.LatLngBounds()
        : null;

      this._addMapZoomEvents();
    } catch (e) {
      console.error('initMapElement error:', e);
    }
    // });
  }
  public getZoom() {
    return this.map?.getZoom();
  }
  private readonly MAP_CONFIG = {
    // disableDefaultUI: true,
    minZoom: 12,
    // maxZoom: 15,
    mapTypeId: 'roadmap',
    // gestureHandling: "none",
    gestureHandling: 'greedy', // allows pinch and wheel zoom
    scrollwheel: true, // enable wheel zoom
    //draggable: false,           // disable panning
    disableDoubleClickZoom: false,
    mapTypeControl: false,
    // gestureHandling: 'greedy',
    streetViewControl: false,
    rotateControl: false,
    center: { lat: this.lat, lng: this.lng },

    tilt: 0,
    fullscreenControl: false,
    //zoomControl: false,
    zoom: 12,
    styles: [
      {
        featureType: 'all',
        elementType: 'labels',
        stylers: [{ visibility: 'off' }],
      },
      {
        featureType: 'administrative',
        elementType: 'labels',
        stylers: [{ visibility: 'on' }],
      },
      {
        featureType: 'poi',
        elementType: 'all',
        stylers: [{ visibility: 'off' }],
      },
    ],
    restriction: {
     latLngBounds: {
  north: 1.552237,  // Taman Daya (Johor Bahru) ≈ 1.552237°N
  south: 0.90,  
  east: 105.00,
  west: 102.75,
},

      // latLngBounds: {
      //   north: 1.47,
      //   south: 1.22,
      //   east: 104.05,
      //   west: 103.62,
      // },
      strictBounds: true,
    },
  };

  public showMap = true;
  public markers: any[] = [];
  removeAllMarkers() {
    for (const marker of this.markers) {
      try {
        marker?.setMap(null);
      } catch (e) { }
    }
    this.markers = [];
  }

  private _createComponent(c, params: Object) {
    const rv = createComponent(c, {
      environmentInjector: this.envInjector,
      elementInjector: this.injector,
    });
    for (const key of Object.keys(params)) {
      // //console.log('input:', key, params[key])
      rv.setInput(key, params[key]);
    }

    // this.appRef.attachView(c.hostView);

    return rv;
  }
  private _getHTMLForComponentType(
    type,
    params: Object,
    { componentClass = '', componentId = '' } = {}
  ) {
    // Defensive: avoid crash on missing product
    try {
      const c = this._createComponent(type, params);

      // Root element of the component
      const hostElem = (c.hostView as any).rootNodes[0] as HTMLElement;

      // Append to an offscreen container so Angular renders child nodes
      const tmpContainer = document.createElement('div');
      tmpContainer.style.height = '15em';
      tmpContainer.style.width = '10em';
      tmpContainer.style.display = 'none';
      document.body.appendChild(tmpContainer);

      tmpContainer.appendChild(hostElem);

      // Force a change detection tick
      c.changeDetectorRef.detectChanges();

      // Now grab the rendered HTML
      let topTag = '<div';
      if (componentClass) {
        topTag += ` class="${componentClass}"`;
      }
      if (componentId) {
        topTag += ` id="${componentId}"`;
      }
      const rv = `${topTag}>${tmpContainer.innerHTML}</div>`;
      // //console.log({ rv });

      // Clean up
      document.body.removeChild(tmpContainer);
      this.appRef.detachView(c.hostView);
      c.destroy();

      return rv;
    } catch (e) {
      console.error(e);
      return '';
    }
  }

  private regionSplit(name: string): string {
    return name && name.includes('|') ? name.split('|')[1] : '';
  }

  public get innerWidth() {
    if (this.sharedService.isBrowser()) {
      return this.window.innerWidth;
    }
    return 0;
  }

  private _categoryListSub: Subscription | null = null;
  private getShareProductsInfoWindow(sharedProducts) {
    //console.log("showing products", sharedProducts)
    if (!sharedProducts?.length) {
      console.error('Invalid share product array!');
      return;
    }
    let contentHTML = `
       <div style='display: grid; grid-template-columns: repeat(${Math.min(
      this.isOnMobile ? 2 : 4,
      sharedProducts.length
    )}, 1fr); width: fit-content !important;
       gap: 0.5rem;
       padding: 0.5rem 0.25rem 0.25rem 0.5rem;
        ;max-height: 60vh; overflow: scroll;
       '>
    `;
    var maxWidth;

    if (this.isOnMobile) {
      maxWidth = '10rem !important;';
    } else {
      maxWidth = '13rem !important;';
    }
    for (let i = 0; i < sharedProducts.length; i++) {
      const product = sharedProducts[i];
      const productIdKey = `common-card-${product?.id}`;
      contentHTML += `<div class='popup-products' style='width: ${maxWidth}'>`;
      contentHTML += this._getHTMLForComponentType(
        CommonProductCardViewComponent,
        { list: product, noCrop: true },
        {
          componentId: productIdKey,
        }
      );
      contentHTML += '</div>';
    }
    contentHTML += '</div>';
    return new google.maps.InfoWindow({
      content: contentHTML,
    });
  }
  private addCommonProductEventToId(productKey, productData) {
    //console.log("getting elemt by id", productKey)
    const element = document.getElementById(productKey);

    if (!element) {
      console.error('Element is not found!');
      return;
    }

    element.addEventListener('click', () => {
      this.markerClick.next(productData);
    });
  }
  private getInfoWindow(product: any, mode: 'promos' | 'products') {
    let midHTML = '';
    let maxWidth = 'unset !important;';
    switch (mode) {
      case 'promos': {
        midHTML = this._getHTMLForComponentType(PromoCardComponent, {
          item: product?.productMoreServices[0],
        });
        break;
      }
      case 'products': {
        if (this.isOnMobile) {
          maxWidth = '10rem !important;';
        } else {
          maxWidth = '13rem !important;';
        }
        midHTML = this._getHTMLForComponentType(
          CommonProductCardViewComponent,
          { list: product, noCrop: true }
        );

        break;
      }
      default: {
        console.error('unknown mode', mode);
        return '';
      }
    }

    const pixelOffset = new google.maps.Size(100, 45);

    const rv = new google.maps.InfoWindow({
      //disableAutoPan: true,
      // pixelOffset,
      content: `
               <div class='popup-products' style='width: ${maxWidth}'>
                 ${midHTML}
               </div>
            `,
    });

    return rv;
  }

  private fetchCategories() {
    // Avoid multiple subscriptions
    if (this._categoryListSub) return;
    //console.log('fetching category info');
    this._categoryListSub = this.commonService.categoryList.subscribe(
      (response: any) => {
        if (this.sharedService.isBrowser()) {
          this.prepProductCategoryImages(response);
        }
      }
    );
  }

  private prepProductCategoryImages(categoryData: any[]) {
    // //console.log('preparing categoryImage', categoryData);
    if (!Array.isArray(categoryData)) return;
    for (const cat of categoryData) {
      if (!cat) continue;
      this.categoryIconMap.set(cat.id, cat.image);
      if (Array.isArray(cat.subCategory)) {
        for (const subCat of cat.subCategory) {
          if (subCat) {
            this.categoryIconMap.set(subCat.categorieChildId, cat.image);
          }
        }
      }
    }
  }

  private categoryIconMap: Map<string, string> = new Map<string, string>();
  //  private currentMapZoomLevel: number | null = null;
  private currentActiveInfoWindow: any = null;
  private currentlyShowingInfoWindowOfMarker: any = null;
  private markerHTMLElements: any[] = [];

  private readonly CIRCLE_IMAGE_MARKER = '#circle-image';
  private readonly GOLDEN_IMAGE_MARKER = 'golden-image';

  public markerClick = new Subject();

  public productMarkerMap = new Map();

  public openInfoWindowOfProduct(product) {
    if (!product.id) {
      return;
    }
    const marker = this.productMarkerMap.get(product.id + '');
    this.currentActiveInfoWindow?.close();
    this.currentActiveInfoWindow = this.getInfoWindow(product, 'products');
    this.currentActiveInfoWindow.open(this.map, marker);
    this.currentlyShowingInfoWindowOfMarker = marker;
  }

  private sharedProduct;
  private getMarkerForSharedProducts(sharedLocation, sharedProducts) {
    if (!sharedProducts?.length) {
      return null;
    }
    const buildingIcons =
      '../../assets/images/building.png' + this.CIRCLE_IMAGE_MARKER;
    try {
      const marker = new google.maps.Marker({
        position: sharedLocation,
        map: this.map,
        icon: {
          url: buildingIcons,
          scaledSize: new google.maps.Size(42, 42),
          origin: new google.maps.Point(0, 0),
          anchor: new google.maps.Point(15, 15),
          labelOrigin: new google.maps.Point(20, 50),
        },
        // label: {
        //   text: `${sharedProducts.length}`,
        //   color: "var(--secondary)",   // or white
        //   fontSize: ".7rem",
        //  // fontWeight: "bold",
        // },
      });
      marker.products = sharedProducts;
      for (const product of sharedProducts) {
        if (!product?.id) {
          continue;
        }
        this.productMarkerMap.set(product?.id + '', marker);
      }

      const closeCurrentInfoWindow = () => {
        try {
          this.currentActiveInfoWindow?.close();
        } catch (e) { }
        this.currentActiveInfoWindow = null;
        this.currentlyShowingInfoWindowOfMarker = null;
      };

      const openMyInfoWindow = (marker: any) => {
        closeCurrentInfoWindow();
        const KEY = JSON.stringify(sharedProducts[0].latLong);
        console.log(
          'KEY=',
          KEY,
          Array.from(this.sharedProductLocationProductsListMap.values())
        );
        const sharedProductsActive =
          this.sharedProductLocationProductsListMap.get(KEY);
        this.currentActiveInfoWindow =
          this.getShareProductsInfoWindow(sharedProductsActive);

        this.currentActiveInfoWindow.open(this.map, marker);
        this.currentlyShowingInfoWindowOfMarker = marker;

        setTimeout(() => {
          for (const product of sharedProductsActive) {
            this.addCommonProductEventToId(
              `common-card-${product?.id}`,
              product
            );
          }
        });

        // openProductWhenPopClicked();
      };

      // marker.addListener('mouseover', () => {
      //   openMyInfoWindow(marker);
      // });
      marker.addListener('click', () => {
        openMyInfoWindow(marker);
      });

      marker.addListener('mouseout', () => {
        // closeCurrentInfoWindow();
      });

      marker.addListener('click', () => {
        //console.log('isOnMobile=', this.isOnMobile);
        if (this.isOnMobile) {
          if (this.currentlyShowingInfoWindowOfMarker == marker) {
            closeCurrentInfoWindow();
          } else {
            openMyInfoWindow(marker);
          }
        } else {
          // this.markerClick.next(sharedProducts[0]);
        }
      });

      this.map.addListener('click', () => {
        closeCurrentInfoWindow();
      });
      return marker;
    } catch (e) {
      return null;
    }
  }

  private getMarkerForProduct(product: any, loc: any, mode) {
    if (!loc || !this.map) return null;

    let iconUrl = '../../assets/images/shop/default.png';
    ////console.log(this.categoryIconMap, product.categoryId);
    // if (this.categoryIconMap.has(product.categoryId)) {
    //   iconUrl = this.imgUrl + this.categoryIconMap.get(product.categoryId);
    //   //console.log(
    //     'product with id=',
    //     product.id,
    //     'categoryId=',
    //     product.categoryId,
    //     'icons=',
    //     iconUrl,
    //   );
    // }
    iconUrl = this.imgUrl + product.indexImage;

    iconUrl += this.CIRCLE_IMAGE_MARKER;
    if (product?.additionalTag?.toLowerCase()?.trim() == 'must try') {
      iconUrl += this.GOLDEN_IMAGE_MARKER;
    }

    let marker: any;
    try {
      marker = new google.maps.Marker({
        position: loc,
        map: this.map,
        icon: {
          url: iconUrl,
          scaledSize: new google.maps.Size(42, 42),
          origin: new google.maps.Point(0, 0),
          anchor: new google.maps.Point(15, 15),
          labelOrigin: new google.maps.Point(20, 50),
        },
      });
      if (this.productMarkerMap.has(product?.id + '')) {
        this.productMarkerMap.delete(product?.id + '');
      }
      this.productMarkerMap.set(product?.id + '', marker);
      marker.productId = product?.id;
    } catch (e) {
      return null;
    }

    const closeCurrentInfoWindow = () => {
      try {
        this.currentActiveInfoWindow?.close();
      } catch (e) { }
      this.currentActiveInfoWindow = null;
      this.currentlyShowingInfoWindowOfMarker = null;
    };
    const openProductWhenPopClicked = () => {
      google.maps.event.addListener(
        this.currentActiveInfoWindow,
        'domready',
        () => {
          document
            .getElementsByClassName('popup-products')[0]
            .addEventListener('click', () => {
              this.markerClick.next(product);
            });
        }
      );
    };

    const openMyInfoWindow = (marker: any) => {
      closeCurrentInfoWindow();
      this.currentActiveInfoWindow = this.getInfoWindow(product, mode);
      this.currentActiveInfoWindow.open(this.map, marker);
      this.currentlyShowingInfoWindowOfMarker = marker;
      openProductWhenPopClicked();
    };

    // marker.addListener('mouseover', () => {
    //   openMyInfoWindow(marker);
    // });
    marker.addListener('click', () => {
      openMyInfoWindow(marker);
    });

    // marker.addListener('mouseout', () => {
    //   closeCurrentInfoWindow();
    // });

    // marker.addListener('click', () => {
    //   //console.log('isOnMobile=', this.isOnMobile);
    //   if (this.isOnMobile) {
    //     if (this.currentlyShowingInfoWindowOfMarker == marker) {
    //       closeCurrentInfoWindow();
    //     } else {
    //       openMyInfoWindow(marker);
    //     }
    //   } else {
    //     this.markerClick.next(product);
    //   }
    // });

    this.map.addListener('click', () => {
      closeCurrentInfoWindow();
    });

    //this.currentMapZoomLevel = this.map.getZoom();

    return marker;
  }
  private readonly MAX_MARKERS = 200;

  private sharedProductLocationProductsListMap = new Map();
  private addMakerForSharedProduct(sharedProducts) {
    //console.log("adding products shared", sharedProducts.length)
    if (!sharedProducts?.length) {
      console.error('zero length shared products given!');
      return;
    }
    const sharedLocation = sharedProducts[0].latLong;
    const KEY = JSON.stringify(sharedLocation);
    if (this.sharedProductLocationProductsListMap.has(KEY)) {
      // console.log("chaning only not setting to", sharedProducts)

      this.sharedProductLocationProductsListMap.delete(KEY);
      this.sharedProductLocationProductsListMap.set(KEY, sharedProducts);
      return;
    }
    this.sharedProductLocationProductsListMap.set(KEY, sharedProducts);

    const marker = this.getMarkerForSharedProducts(
      sharedLocation,
      sharedProducts
    );
    if (marker) {
      this.markers.push(marker);
    }
  }

  private addMarkerForProduct(product, mode) {
    try {
      let loc = product.latLong;

      if (loc && typeof loc === 'object' && 'lat' in loc && 'lng' in loc) {
        const latLng = new google.maps.LatLng(loc.lat, loc.lng);
        const marker = this.getMarkerForProduct(product, latLng, mode);

        if (marker) {
          this.markers.push(marker);
        }
      }
    } catch (e) {
      console.error('addProductDataToMap error:', e);
    }
  }

  private checkIfInMap(lat: number, lng: number): boolean {
    const mapBounds = this.getBounds(); // {fromLat, toLat, fromLng, toLng}

    if (!mapBounds) return false;
    //5% padding
    const paddingPercentageDecimal = 0.05;
    return (
      lat >= mapBounds.fromLat * (1 - paddingPercentageDecimal) &&
      lat <= mapBounds.toLat * (1 + paddingPercentageDecimal) &&
      lng >= mapBounds.fromLng * (1 - paddingPercentageDecimal) &&
      lng <= mapBounds.toLng * (1 + paddingPercentageDecimal)
    );
  }

  public async addProductDataToMap(
    products,
    mode: 'promos' | 'products' = 'products'
  ) {
    const productsArray = Array.isArray(products)
      ? products.flat().filter(Boolean)
      : [];

    const productsIdsSet = new Set(productsArray.map((product) => product.id));

    // Limit the number of markers to avoid lag/crash
    let markerCount = 0;
    const uniqueLocationProducts = [];
    const sameLocationProducts = [];

    const productsWithTheSameLocation = new Map<string, any[]>();

    for (const product of productsArray) {
      const location = JSON.stringify(product.latLong);

      if (productsWithTheSameLocation.has(location)) {
        productsWithTheSameLocation.get(location).push(product);
      } else {
        productsWithTheSameLocation.set(location, [product]);
      }
    }
    for (const key of productsWithTheSameLocation.keys()) {
      const savedProducts = productsWithTheSameLocation.get(key);
      if (savedProducts.length == 1) {
        uniqueLocationProducts.push(savedProducts[0]);
      } else {
        sameLocationProducts.push(savedProducts);
      }
    }
    for (let j = 0; j < sameLocationProducts.length; j++) {
      const sharedLocationProducts = sameLocationProducts[j];
      this.addMakerForSharedProduct(sharedLocationProducts);
    }

    for (let i = 0; i < uniqueLocationProducts.length; i++) {
      if (markerCount >= this.MAX_MARKERS) {
        console.error(
          `Marker limit (${this.MAX_MARKERS}) reached, skipping remaining products.`
        );
        break;
      }

      const product = uniqueLocationProducts[i];

      if (
        !product ||
        !product.id ||
        this.productMarkerMap.has(product?.id + '')
      ) {
        continue;
      }

      this.addMarkerForProduct(product, mode);

      markerCount++;
    }
    this.checkAndRemoveMarkers(productsIdsSet);
  }
  private checkAndRemoveMarkers(productsIdsSet: Set<any>) {
    //console.log("removing markers from size of ", this.markers.length)
    const newMarkers = [];
    for (const marker of this.markers) {
      if (marker.productId && marker.position) {
        //single product marker
        //console.log("marker detail", marker.position, marker.productId)
        if (
          this.checkIfInMap(marker.position.lat(), marker.position.lng()) &&
          !productsIdsSet.has(marker.productId)
        ) {
          marker?.setMap(null);
          this.productMarkerMap.delete(marker.productId + '');
          //delete marker;
        } else {
          marker.setMap(this.map);
          newMarkers.push(marker);
        }
      } else if (marker.products && marker.position) {
        if (
          this.checkIfInMap(marker.position.lat(), marker.position.lng()) &&
          marker?.products?.find((product) => !productsIdsSet.has(product?.id))
        ) {
          marker?.setMap(null);
          for (const product of marker.products) {
            this.productMarkerMap.delete(product.id + '');
          }
          const KEY = JSON.stringify(marker.products[0].latLong);
          this.sharedProductLocationProductsListMap.delete(KEY);
        } else {
          //  const KEY = JSON.stringify(marker.products[0].latLong)
          // this.sharedProductLocationProductsListMap.set(KEY, marker)
          marker.setMap(this.map);
          newMarkers.push(marker);
        }
      }
    }
    this.markers = newMarkers;
  }

  private mapDivId = 'map';

  // private changeMapMarkerColors() {
  //   if (!this.mapDivId) return;
  //   const mapImages = document.querySelectorAll(`#${this.mapDivId} img`);
  //   if (!mapImages) {
  //     return;
  //   }
  //   // mapImages.forEach((img: any) => {
  //   //   if (
  //   //     (!img.src?.includes('kachiing') &&
  //   //       !img.src?.includes('localhost:4200')) ||
  //   //     img.src?.includes('food')
  //   //   )
  //   //     return;

  //   //   img.classList.add('circle-image');
  //   //   if (img.src?.includes(this.CIRCLE_IMAGE_MARKER)) {
  //   //     img.classList.add('circle-image-2');
  //   //   } else {
  //   //     img.classList.add('circle-image-2');
  //   //   }
  //   // });
  // }

  onImgError(event: any) {
    if (event?.target) {
      event.target.src = '../../assets/images/shop/default.png';
    }
  }
}
